import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/chat-layout.css";
import "@/messages-polish.css";
import "@/public-chat.css";
import "@/home-polish.css";
import "@/profile-polish.css";
import "@/site-polish.css";
import "@/messages-scroll-fix.js";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>,
  </React.StrictMode>,
);
